import React from 'react';

export const US = () => {
	return (
		<svg
			width='20'
			height='15'
			viewBox='0 0 20 15'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g>
				<mask
					style={{ maskType: 'alpha' }}
					maskUnits='userSpaceOnUse'
					x='0'
					y='0'
					width='20'
					height='15'
				>
					<rect width='20' height='15' fill='white' />
				</mask>
				<g>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 0H20V15H0V0Z'
						fill='#E31D1C'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 1.25V2.5H20V1.25H0ZM0 3.75V5H20V3.75H0ZM0 7.5V6.25H20V7.5H0ZM0 8.75V10H20V8.75H0ZM0 12.5V11.25H20V12.5H0ZM0 15V13.75H20V15H0Z'
						fill='#F7FCFF'
					/>
					<rect width='11.25' height='8.75' fill='#2E42A5' />
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M1.30002 2.71722L1.96242 2.2558L2.47624 2.62572H2.18532L2.77365 3.14609L2.57494 3.87572H2.2637L1.96149 3.2056L1.70376 3.87572H0.935318L1.52365 4.39609L1.30002 5.21722L1.96242 4.7558L2.47624 5.12572H2.18532L2.77365 5.64609L2.57494 6.37572H2.2637L1.96149 5.7056L1.70376 6.37572H0.935318L1.52365 6.89609L1.30002 7.71722L1.96242 7.2558L2.60334 7.71722L2.40407 6.89609L2.91878 6.37572H2.68137L3.21242 6.0058L3.72624 6.37572H3.43532L4.02365 6.89609L3.80002 7.71722L4.46242 7.2558L5.10334 7.71722L4.90407 6.89609L5.41878 6.37572H5.18137L5.71242 6.0058L6.22624 6.37572H5.93532L6.52365 6.89609L6.30002 7.71722L6.96242 7.2558L7.60334 7.71722L7.40407 6.89609L7.91878 6.37572H7.68137L8.21242 6.0058L8.72624 6.37572H8.43532L9.02365 6.89609L8.80002 7.71722L9.46242 7.2558L10.1033 7.71722L9.90407 6.89609L10.4188 6.37572H9.7637L9.46149 5.7056L9.20376 6.37572H8.83113L8.65407 5.64609L9.16878 5.12572H8.93137L9.46242 4.7558L10.1033 5.21722L9.90407 4.39609L10.4188 3.87572H9.7637L9.46149 3.2056L9.20376 3.87572H8.83113L8.65407 3.14609L9.16878 2.62572H8.93137L9.46242 2.2558L10.1033 2.71722L9.90407 1.89609L10.4188 1.37572H9.7637L9.46149 0.705597L9.20376 1.37572H8.43532L9.02365 1.89609L8.82494 2.62572H8.5137L8.21149 1.9556L7.95376 2.62572H7.58113L7.40407 1.89609L7.91878 1.37572H7.2637L6.96149 0.705597L6.70376 1.37572H5.93532L6.52365 1.89609L6.32494 2.62572H6.0137L5.71149 1.9556L5.45376 2.62572H5.08113L4.90407 1.89609L5.41878 1.37572H4.7637L4.46149 0.705597L4.20376 1.37572H3.43532L4.02365 1.89609L3.82494 2.62572H3.5137L3.21149 1.9556L2.95376 2.62572H2.58113L2.40407 1.89609L2.91878 1.37572H2.2637L1.96149 0.705597L1.70376 1.37572H0.935318L1.52365 1.89609L1.30002 2.71722ZM8.82494 5.12572L9.02365 4.39609L8.43532 3.87572H8.72624L8.21242 3.5058L7.68137 3.87572H7.91878L7.40407 4.39609L7.58113 5.12572H7.95376L8.21149 4.4556L8.5137 5.12572H8.82494ZM7.47624 5.12572L6.96242 4.7558L6.43137 5.12572H6.66878L6.15407 5.64609L6.33113 6.37572H6.70376L6.96149 5.7056L7.2637 6.37572H7.57494L7.77365 5.64609L7.18532 5.12572H7.47624ZM5.27365 5.64609L5.07494 6.37572H4.7637L4.46149 5.7056L4.20376 6.37572H3.83113L3.65407 5.64609L4.16878 5.12572H3.93137L4.46242 4.7558L4.97624 5.12572H4.68532L5.27365 5.64609ZM5.45376 5.12572H5.08113L4.90407 4.39609L5.41878 3.87572H5.18137L5.71242 3.5058L6.22624 3.87572H5.93532L6.52365 4.39609L6.32494 5.12572H6.0137L5.71149 4.4556L5.45376 5.12572ZM3.82494 5.12572L4.02365 4.39609L3.43532 3.87572H3.72624L3.21242 3.5058L2.68137 3.87572H2.91878L2.40407 4.39609L2.58113 5.12572H2.95376L3.21149 4.4556L3.5137 5.12572H3.82494ZM7.77365 3.14609L7.57494 3.87572H7.2637L6.96149 3.2056L6.70376 3.87572H6.33113L6.15407 3.14609L6.66878 2.62572H6.43137L6.96242 2.2558L7.47624 2.62572H7.18532L7.77365 3.14609ZM4.97624 2.62572L4.46242 2.2558L3.93137 2.62572H4.16878L3.65407 3.14609L3.83113 3.87572H4.20376L4.46149 3.2056L4.7637 3.87572H5.07494L5.27365 3.14609L4.68532 2.62572H4.97624Z'
						fill='#F7FCFF'
					/>
				</g>
			</g>
			<rect
				x='0.5'
				y='0.5'
				width='19'
				height='14'
				rx='1'
				stroke='black'
				strokeOpacity='0.1'
				style={{ mixBlendMode: 'multiply' }}
			/>
			<defs>
				<clipPath>
					<rect width='20' height='15' rx='1.5' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};
